import { LBAvatar, LBAvatarImage, LBAvatarFallback } from '@linearb/buzz'
import type { AccountInfo } from '../types'

interface AccountLabelProps {
  accountId?: number | null
  account?: AccountInfo | null
  size?: number
  // Typography for the name — defaults to the table person-cell style.
  textClassName?: string
  className?: string
}

const toInitials = (label: string): string =>
  label
    .split(/[\s@._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(w => w[0]?.toUpperCase())
    .join('') || '?'

// Renders an account as avatar + name. Falls back to "Account {id}" until resolved.
const AccountLabel: React.FC<AccountLabelProps> = ({
  accountId,
  account,
  size = 24,
  textClassName = 'text-sm text-foreground',
  className = ''
}) => {
  if (accountId == null && !account) {
    return null
  }
  const id = account?.id ?? accountId
  const label = account?.name || account?.email || `Account ${id}`
  return (
    <span className={`inline-flex items-center gap-2 min-w-0 ${className}`}>
      <LBAvatar style={{ width: size, height: size }} className='shrink-0'>
        {account?.avatar_url && (
          <LBAvatarImage src={account.avatar_url} alt={label} />
        )}
        <LBAvatarFallback className='bg-primary text-primary-foreground text-[10px]'>
          {toInitials(label)}
        </LBAvatarFallback>
      </LBAvatar>
      <span className={`truncate ${textClassName}`}>{label}</span>
    </span>
  )
}

export default AccountLabel
